module.exports = __webpack_public_path__ + "img/05_slides.afdf6be5.png";